module.exports = __webpack_public_path__ + "static/media/foodBag.47c03e03.jpg";